import { useState, useEffect, useCallback, useMemo } from 'react';
import { LeadStatusService } from '@layouts/pages/Settings/general/lead-status/services/lead-status.service';
import { LeadStatusResponse } from '@layouts/pages/Settings/general/lead-status/services/responses/lead-status.response';

export const useLeadStatus = () => {
    const [statuses, setStatuses] = useState<LeadStatusResponse[]>([]);
    const service = useMemo(() => new LeadStatusService(), []);

    const fetchAll = useCallback(async () => {
        try {
            const res = await service.getList();
            setStatuses(res.data.data ?? []);
        } catch (e) {
            console.error(e);
        }
    }, [service]);

    useEffect(() => {
        fetchAll();
    }, [fetchAll]);

    return { statuses, refetch: fetchAll };
};
